import React from 'react';

import styles from './styles.module.scss';
import { LogoAG1Icon, LogoAGZIcon } from '@ag1/ui';

interface FooterLogoProps {
  isAGZ?: boolean;
}

const FooterLogo = ({ isAGZ = false }: FooterLogoProps) => {
  if (isAGZ) {
    return <LogoAGZIcon className={styles.logo} />;
  }

  return <LogoAG1Icon className={styles.logo} />;
};

export default FooterLogo;
